import { Dropdown } from 'bootstrap'
import React from 'react'
import DropDown from '../DropDown'

export default function DropDowm(props) {
	const {visible}=props
    return (
        <div className={`sidebar ${visible}`} id="sidebar">
		<div className="sidebar-content">
			<div className="sidebar-header">
				<span className="title">DEV Community</span>
				<button type="button" className="" aria-label="Close" data-toggle="collapse" data-target="#sidebar"
				aria-expanded="false" aria-label="Toggle navigation">
				<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<nav className="d-flex icons section-list collapse" id="section-list" aria-expanded="">
				<a href="#" className="item-list">
					<span><img src="img/icons/home.svg" alt=""/></span>Home</a>
				<a href="#" className="item-list">
					<span><img src="img/icons/readinglist.svg" alt=""/></span>Reading List</a>
				<a href="#" className="item-list">
					<span><img src="img/icons/listings.svg" alt=""/></span>Listings</a>
				<a href="#" className="item-list">
					<span><img src="img/icons/podcasts.svg" alt=""/></span>Podcasts</a>
				<a href="#" className="item-list">
					<span className="crayons-icon crayons-icon--default"><img src="img/icons/videos.svg"
							alt=""/></span>Videos</a>
				<a href="#" className="item-list">
					<span><img src="img/icons/tags.svg" alt=""/></span>Tags</a>
				<a href="#" className="item-list">
					<span><img src="img/icons/code-of-conduct.svg" alt=""/></span>Code of Coduct</a>
				<a href="#" className="item-list">
					<span><img src="img/icons/faq.svg" alt=""/></span>FAQ</a>
				<a href="#" className="item-list">
					<span><img src="img/icons/dev-shop.svg" alt=""/></span>DEV Shop</a>
				<a href="#" className="item-list">
					<span><img src="img/icons/about.svg" alt=""/></span>About</a>
				<a href="#" className="item-list">
					<span><img src="img/icons/privacy-policy.svg" alt=""/></span>Privacy Policy</a>
				<a href="#" className="item-list">
					<span><img src="img/icons/terms-of-use.svg" alt=""/></span>Terms of use</a>
				<a href="#" className="item-list">
					<span><img src="img/icons/contact.svg" alt=""/></span>Contact</a>

				<div className="mt-5 social-icons"> 
					<a href="https://twitter.com/thepracticaldev" target="_blank"
						className="" rel="noopener">
						<img src="img/icons/twitter.svg" alt="twitter"/>
					</a>
					<a href="https://facebook.com/thepracticaldev" target="_blank">
						<img src="img/icons/facebook.svg" alt="facebook"/>
					</a>
					<a href="https://github.com/thepracticaldev" target="_blank">
						<img src="img/icons/github.svg" alt="github"/>
					</a>
					<a href="https://instagram.com/thepracticaldev" target="_blank"
						className="crayons-link crayons-link--secondary mx-2" rel="noopener">
						<img src="img/icons/instagram.svg" alt="instagram"/>
					</a>
					<a href="https://twitch.com/thepracticaldev" target="_blank"
						className="crayons-link crayons-link--secondary mx-2" rel="noopener">
						<img src="img/icons/twitch.svg" alt="twitch"/>
	
					</a>
				</div>	
			</nav>
			<div className="view-more-sections">
				<button data-toggle="collapse" data-target="#section-list">More...</button>
			</div>
		</div>
		<div className="sidebar-overlay">
		</div>
	</div>
    )
}
